import React from "react";
import AddButtonPopover from './AddButtonPopover';

export default class AddButtonNew extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      dataOptions: [],
      viewPopover: false,
      offset: 0,
      sortData: this.props.sortData || false
    };
    this.addButton = React.createRef()
  };

  componentDidMount(){
    $(window).on('click', (e)=>{
      !$(e.target).parents('#add-button-top-parent').length && this.state.viewPopover ? this.setState({viewPopover:false}) : null;
    });

    this.load();
  };

  componentDidUpdate(prevProps){
    // this.state.offset !== this.addButton.current.offsetWidth ? this.setState({offset: this.addButton.current.offsetWidth}) : null;

    if (this.props && !this.arraysEqual(prevProps.ids, this.props.ids)) {
      this.load(this.props);
    }
    if (this.props && this.props.room_type && nextProps.room_type && this.props.room_type.id != nextProps.room_type.id) {
      this.load(this.props);
    }
  };

  componentWillUnmount(){
    $(window).off('click')
  }

  arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    };
    return true;
  };

  render(){
    
    return(
      <div className="add-button" id="add-button-top-parent">
        <button ref={this.addButton} disabled={this.props.disabled} onClick={ () => this.setState({ viewPopover: !this.state.viewPopover }) } type="button" className={this.props.buttonClasses || "btn btn-primary btn-xs"}>{this.props.text ? this.props.text : I18n.t('add_model', { model: I18n.t(this.props.model.toLowerCase()) })}</button>
        <AddButtonPopover {...this.state} model={this.props.model} generalPosition={this.props.generalPosition} onAdd={this.onAdd} sortData={this.state.sortData} searchInput={this.props.searchInput} searchFunction={this.props.searchFunction}/>
      </div>
    );
  };
  
  load(props=this.props) {
    var self = this
    // var props = props || this.props;
    $.ajax({
      type: 'POST',
      url: '/admin/add-button/' + props.model,
      data: this.params(props)
    }).done((data) => {
      self.setState({ dataOptions: data, offset: self.addButton.current ? self.addButton.current.offsetWidth : self.state.offset });
    });
  };
  
  params(props) {
    var params = '';

    if (props.column) {
      params += '&column=' + props.column;
    };

    if (props.ids && props.ids.length) {
      params += '&ids=' + props.ids;
    };

    if (props.room_type) {
      params += '&room_type_id=' + props.room_type.id;
    };;

    if (typeof props.is_automatically_applied !== 'undefined') {
      params += '&is_automatically_applied=' + props.is_automatically_applied;
    };

    if (props.reservation_segment) {
      params += '&reservation_segment_id=' + props.reservation_segment.id;
    };

    if (props.view_type) {
      params += '&view_type=' + props.view_type;
    };

    if(props.document_form == true){
      params += '&document_form=' + props.document_form
    };

    if(props.survey_form == true){
      params += '&survey_form=' + props.survey_form
    };

    if(props.order_form == true){
      params += '&order_form=' + props.order_form
    };

    return params;
  };

  onAdd = (json) => {

    if (typeof this.props.onAdd == 'function') {
      this.props.onAdd(json);
    }

    this.setState({viewPopover: false})
  };

};
